import { useState, useEffect } from "react";
import { getDateFormaterURL } from "../../utils/ConstantsURL";

export const useGetDateFormats = (token) => {
  const [dateFormats, setDateFormats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDateFormats = async () => {
      if (!token) return;

      setLoading(true);
      setError(null);

      try {
        const response = await fetch(getDateFormaterURL(), {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const payload = await response.json();
        const rawFormats = Array.isArray(payload)
          ? payload
          : payload?.data || payload?.formats || [];

        const transformedData = (Array.isArray(rawFormats) ? rawFormats : [])
          .map((item) => ({
            value: item.id || item.value,
            label: item.name || item.label,
            example: item.example || item.preview || "",
          }))
          .filter((item) => item.value);

        setDateFormats(transformedData);
      } catch (error) {
        console.error("Error fetching date formats:", error);
        setError(error.message);
        setDateFormats([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDateFormats();
  }, [token]);

  return { dateFormats, loading, error };
};